// Disabling this because lots of variables declared in case statements
// but in this file that is fine
/* eslint-disable no-case-declarations */
import React from "react";
import CommunicationModel from "../../models/communications/Communication";
import Communication from "./Communication";
import EditorWrapper from "../ui/EditorWrapper";
import { buildMinimumNotificationFrequencyMetric, getRandomInt } from "../../helpers/DataUpdateHelper";
// import Communication from './Communication';

import { useEffect, useState } from "react";
import {
  communicationsCopyHandleFetchsHandleFetch,
  communicationsHandleFetchsHandleFetch,
  compareCommunications,
  stateDeepCopy,
} from "../../helpers/DataUpdateHelper";
import useHttp from "../../hooks/useHttp";
import CommunicationSetModel from "../../models/communications/CommunicationSet";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import Tooltip from "@mui/material/Tooltip";
import LinearProgress from "@mui/material/LinearProgress";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Stack from "@mui/material/Stack";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import CommunicationSet from "../../models/communications/CommunicationSet";
import { useRowSelector, useStoreDispatch, useStoreSelector } from "../../store/Hooks";
import { interactionTreeSliceActions } from "../../store/slices/InteractionTreeSlice";
import CommunicationSettings from "../../models/config/CommunicationSettings/CommunicationSettings";
import SearchIcon from "@mui/icons-material/Search";
import IosShareIcon from "@mui/icons-material/IosShare";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import WarningIcon from "@mui/icons-material/Warning";
import Interval from "../../models/communications/Interval";
import InteractionNodeInterval from "../../models/interactions/InteractionNodeInterval";
import { navSliceActions } from "../../store/slices/NavSlice";
import { postgrest_operators } from "../../helpers/HttpHelper";
import { useTranslation } from "react-i18next";
import { enqueueSnackbar } from "notistack";
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { CopyProps } from "../../models/interactions/InteractionNode";
import { useDispatch } from "react-redux";
import MessageSettings from "../../models/config/CommunicationSettings/MessageSettings";
import MediumSettings, { LocationSettingsDataProps } from "../../models/config/CommunicationSettings/MediumSettings";
import LocalizationSettings from "../../models/config/CommunicationSettings/LocalizationSettings";
import { countriesNonUS, countries } from "../localization/LanguageSelector";
import InteractionCopyButton from "../interactions/ui/InteractionCopyButton";

const testing = process.env.REACT_APP_TEST_MODE === "test";

export interface Comm {
  comm_id: number;
  comm_set_id: number;
  start: string;
  end: string;
  properties: Properties;
}

export interface Properties {
  type: string;
  medium: string;
  message: string;
  subject: string;
  priority: string;
  notification_minimum_frequency: number;
}

interface CommunicationSetProps {
  communicationSetID: number;
  resourceName: string; // so it says something like "Edit Communication Set for Parent of Interval #1"
  resourceID: number; // so it says something like "Edit Communication Set for Parent of Interval #1
  intervalID?: number | null; // this is needed for interaction_parent_interval, if we need to create a new one need to know the corresponding interval
  currentParent?: number | null; // this is needed for interaction_parent_interval, if we need to create a new one need to know the corresponding parent
  inDrawer?: boolean; // whether editor is displayed in a STAND-ALONE drawer or not (if nested inside other drawers this should be FALSE)
  drawerAccordion?: boolean; // if editor is nested inside another editor/drawer, it should show within an exapandable accordion and NOT in a standalone drawer
  handleUpdateCommSet?: (id: number | null) => void;
  intervalSetEditMode?: boolean;
  previewMode?: boolean;
}

const CommunicationSetEditor = (props: CommunicationSetProps) => {
  const [communicationSetID, setCommunicationsSetID] = useState<number | null>(
    -1,
  );
  const interval = props.resourceID ? useRowSelector(Interval, props.resourceID) : null;
  const interactionNodeInterval = props.resourceID ? useRowSelector(InteractionNodeInterval, props.resourceID) : null;
  const communicationSet = useRowSelector(CommunicationSetModel, communicationSetID || props.communicationSetID);
  const selectedEntityIDRedux = useStoreSelector(
    (state) => state.nav.selectedEntityID,
  );
  const { t } = useTranslation()
  const dispatch = useDispatch();

  const rightDrawerData = useStoreSelector(
    (state) => state.nav.rightDrawerData,
  );

  let defaultEditMode = true;
  if (typeof props.intervalSetEditMode !== "undefined") {
    defaultEditMode = props.intervalSetEditMode;
  }

  const [communicationSetShared, setCommunicationsSetShared] = useState<
    boolean
  >(communicationSet?.shared || false);

  // const [editMode, setEditMode] = useState<boolean>(defaultEditMode);
  const [editMode, setEditMode] = useState<boolean>(true);

  const [searchMode, setSearchMode] = useState<boolean>(false);

  const [communicationsList, setCommunicationsList] = useState<
    Array<CommunicationModel>
  >([]);

  const [prioritiesList, setPrioritiesList] = useState<Array<string>>([]);
  // const [communicationSetList, setCommunicationsSetList] = useState<{}[]>([]);
  const [communicationSetName, setCommunicationsSetName] = useState<
    string | null
  >(null);

  const { isLoading, sendRequest: fetchData } = useHttp();

  //save CommunicationsSet And Communications
  const addNewCommunicationSet = async () => {
    let insertedCommunicationSetID: string | null = null;

    // save communicationSetName (if changed on communicationSet record)
    // take as much from interval name by default as possible
    // otherwise, just add a generic name
    // ***commset names must be unique***
    const name = interval ? interval.name + " " + getRandomInt(0, 900000000) : "Communication Set #" + getRandomInt(0, 900000000);
    const data = {
      name: name,
    };

    // save to db and update redux
    const newCommSet = await CommunicationSet.createInstance(data).save();
    // grab newly inserted ID
    insertedCommunicationSetID = '' + newCommSet.id

    // update local UI state    
    // update local component state
    if (insertedCommunicationSetID) {
      await setCommunicationsList([]);
      await setCommunicationsSetName(name);
      await setCommunicationsSetID(parseInt(insertedCommunicationSetID));
      await setEditMode(true);
    }

    return insertedCommunicationSetID;
  };

  // save new communication to db
  // update UI state
  const addNewCommunication = async () => {
    // if no current commSet assigned, make immediately make a new one for this entity
    // and enter edit modes where needed
    let newCommunicationSetID: string | null = null;
    if (
      (!props.communicationSetID || props.communicationSetID === -1) &&
      communicationsList.length == 0
    ) {
      newCommunicationSetID = await addNewCommunicationSet();
      if (newCommunicationSetID) {
        await setCommunicationsSetID(parseInt(newCommunicationSetID));
      }
    }

    let insertedCommunicationID: number | null = null;

    const communication_set_id = newCommunicationSetID
      ? newCommunicationSetID
      : communicationSetID;

    const message = MessageSettings.create();

    const start = 0;
    const end = 0;
    const priority = "";
    const type = "notification";
    const notification_minimum_frequency = 1;

    const properties: CommunicationSettings = new CommunicationSettings(
      type,
      priority,
      notification_minimum_frequency,
      message,
    );

    // set data for db commit
    const data = {
      communication_set_id: communication_set_id,
      thestart: start,
      theend: end,
      theproperties: properties,
    };
    const url: string =
      process.env.REACT_APP_API_URL + "/rpc/create_new_communication";
    const requestSettings = {
      url: url,
      method: "POST",
      body: data,
      headers: {
        Authorization: "Bearer " + process.env.REACT_APP_POSTGREST_JWT,
        "Content-Type": "application/json",
        "Content-Profile": testing ? "test" : "build"
      },
    };
    await fetchData(requestSettings, (data: any) => {
      insertedCommunicationID = data;
    });

    // update local UI state
    // pass in ids inserted into db records so Redux is hydrated with these values
    if (insertedCommunicationID) {
      const newCommunication = new CommunicationModel(
        insertedCommunicationID,
        communication_set_id ? parseInt("" + communication_set_id) : null,
        "" + start,
        "" + end,
        new CommunicationSettings(
          type,
          priority,
          notification_minimum_frequency,
          message,
        ),
        "1900-01-01 00:00:00",
        undefined,
        true,
      );
      let stateCopy = [...communicationsList];

      // make sure all other existing comms are not marked as just added
      stateCopy = stateCopy.map((communication: CommunicationModel) => {
        communication.justAdded = false;
        return communication;
      });

      stateCopy.push(newCommunication);

      // sort communications in order of start metric (could be % or hard start)
      stateCopy.sort(compareCommunications);
      setCommunicationsList(stateCopy);
    }
  };


  // pull the current state of each communication and save that to DB
  const saveCommunicationsData = async () => {
    // save communicationSetName (if changed on communicationSet record)
    communicationsList.forEach((communication) => {
      // before committing, remove the justAdded prop
      // since its for UI-only
      delete communication.justAdded;

      // when committing to db make sure notification_minimum_frequency is in '1day' or '1%' format
      communication.properties.notification_minimum_frequency = buildMinimumNotificationFrequencyMetric(
        '' + communication.properties.notification_minimum_frequency,
        communication.properties.notification_minimum_frequency_unit
      )

      // make ending value negative for sendonceduringinterval if not already negative
      // include "days" descriptor if missing
      if (communication.properties.notification_strategy === "sendonceduringinterval") {
        if (!communication.start.includes('days')) {
          communication.start = communication.start + " days";
        }
        if (!communication.end.includes('-')) {
          communication.end = "-" + communication.end;
        }
        if (!communication.end.includes('days')) {
          communication.end = communication.end + " days";
        }
      }

      // TODO/FIXME - this will need to loop through all languages to check
      // if a certain communication medium has no provided settings,
      // just remove it from the object completely
      communication = CommunicationModel.cleanup(communication);

      if (LocalizationSettings.isEmpty(communication.properties.message.app?.en as LocalizationSettings)
        && LocalizationSettings.isEmpty(communication.properties.message.app?.es as LocalizationSettings)) {
        delete communication.properties.message.app;
      }
      if (LocalizationSettings.isEmpty(communication.properties.message.email?.en as LocalizationSettings)
        && LocalizationSettings.isEmpty(communication.properties.message.email?.es as LocalizationSettings)) {
        delete communication.properties.message.email;
      }
      if (LocalizationSettings.isEmpty(communication.properties.message.sms?.en as LocalizationSettings)
        && LocalizationSettings.isEmpty(communication.properties.message.sms?.es as LocalizationSettings)) {
        delete communication.properties.message.sms;
      }
      console.log(communication.properties.message)
      const data = communication;
      const url: string =
        process.env.REACT_APP_API_URL +
        "/communication?id=eq." +
        communication.id;
      const requestSettings = {
        url: url,
        method: "PUT",
        body: data,
        headers: {
          Authorization: "Bearer " + process.env.REACT_APP_POSTGREST_JWT,
          "Content-Type": "application/json",
          "Content-Profile": testing ? "test" : "build"
        },
      };
      fetchData(requestSettings);
      // we are doing it this way instead of failing on a save error
      // because communications are always lazy loaded and arent usually in redux
      const issues: Array<string> = []
      communicationsList.forEach((communication) => {
        if (!communication.properties.notification_strategy) {
          issues.push('One or more communications are missing Notification Strategy');
        }

        if (!communication.properties.priority || communication.properties.priority === "") {
          issues.push('One or more communications are missing Priority');
        }
      });
      issues.forEach((communicationError) => {
        enqueueSnackbar(communicationError, { variant: "error" });
      })
    });
  };

  const handleCopyCommunication = (communication: CommunicationModel) => {
    const stateCopy = [...communicationsList];
    stateCopy.push(communication);
    // sort communications in order of start metric (could be % or hard start)
    stateCopy.sort(compareCommunications);
    setCommunicationsList(stateCopy);
  }

  //save CommunicationsSet And Communications
  const assignSetToEntity = async (updateDelete = false) => {
    let communicationSetToUpdate = communicationSetID;
    // we only want to update the entity if this is null or a positive integer, not -1
    if (communicationSetToUpdate == -1) {
      return;
    }
    switch (props.resourceName) {
      case "interaction_node_interval":
        if (updateDelete) {
          communicationSetToUpdate = null;
        }
        if (interactionNodeInterval) {
          interactionNodeInterval.update("communication_set_id", communicationSetToUpdate).save()
        }
        break;
      case "interval":
        if (updateDelete) {
          communicationSetToUpdate = null;
        }
        if (interval) {
          const updatedInterval = interval.update("communication_set_id", communicationSetToUpdate)
          // probably dont need to assign the commsets to intervals here 
          // if we're in commset drawer over intervals drawer
          // 2 drawers open means we dont want to save
          if (rightDrawerData.length < 2) {
            await updatedInterval.save()
          }
        }
        break;
      default:
      // code block
    }

    if (communicationSetID && communicationSetName) {
      // save redux state
      communicationSet?.update('name', communicationSetName).save()
    }
  };

  // because of issues with MUI autocomplete not easily allowing a way to find the ID, we must embed it in the name ¯\_(ツ)_/¯
  const getCommunicationsForSet = async (setID: number) => {
    // set the dropdown list logic

    // dont try to grab stuff for empty set
    if (setID == -1 || setID == null) {
      return;
    }
    const url: string =
      process.env.REACT_APP_API_URL +
      "/communication?communication_set_id=eq." +
      setID;
    const requestSettings = {
      url: url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + process.env.REACT_APP_POSTGREST_JWT,
        "Accept-Profile": testing ? "test" : "build"
      },
    };
    await fetchData(requestSettings, (data: Array<CommunicationModel>) => {
      const fetchedCommunications =
        communicationsHandleFetchsHandleFetch(data);
      // sort communications in order of start metric (could be % or hard start)
      fetchedCommunications.sort(compareCommunications);
      setCommunicationsList(fetchedCommunications);
    });

  };



  useEffect(() => {
    // when component is first rendered, pull the communication set associated with the current resource
    // then set the name, ID, and pull the array of communications contained within this set
    const hydrate = async () => {
      const prioritiesResponse = await CommunicationModel.getPriorities()
      const priorities = await prioritiesResponse.json();
      setPrioritiesList(priorities)
      const id = props.communicationSetID;
      const url: string =
        process.env.REACT_APP_API_URL + "/communication_set?id=eq." + id;
      const requestSettings = {
        url: url,
        method: "GET",
        headers: {
          Authorization: "Bearer " + process.env.REACT_APP_POSTGREST_JWT,
          "Accept-Profile": testing ? "test" : "build"
        },
      };

      await fetchData(requestSettings, (data: Array<CommunicationSetModel>) => {
        const communicationSets = data.map((item) => {
          return { label: item.name, id: item.id, shared: item.shared };
        });

        const thisCommSet = communicationSets.filter((commSet) => {
          return props.communicationSetID === commSet.id;
        })[0];
        if (thisCommSet.label && thisCommSet.label?.length > 0) {
          // setEditMode(false);
        }
        setCommunicationsSetName(thisCommSet.label);
        setCommunicationsSetID(thisCommSet.id);
        setCommunicationsSetShared(thisCommSet.shared);

        // fetch chaining - fetch communications within the set
        getCommunicationsForSet(props.communicationSetID);
        if (thisCommSet.shared) {
          setEditMode(false)
        }
      });
    };
    hydrate();
    // if this value is falsey, its a brand new set
    if (!props.communicationSetID) {
      addNewCommunication()
    }
  }, [selectedEntityIDRedux]);

  const handleDeleteCommunication = async (communicationID: number) => {
    // update db
    const url: string =
      process.env.REACT_APP_API_URL + "/communication?id=eq." + communicationID;
    const requestSettings = {
      url: url,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + process.env.REACT_APP_POSTGREST_JWT,
        "Content-Type": "application/json",
        "Content-Profile": testing ? "test" : "build"
      },
    };
    if (process.env.REACT_APP_DEV_MODE === "OFF") {
      await fetchData(requestSettings);
    }

    // find communication in local state array
    // copy state, delete from there, save state
    const objIndex = communicationsList.findIndex(
      (obj) => obj.id === communicationID,
    );
    const communicationsListCopy = Array.from(communicationsList);
    communicationsListCopy.splice(objIndex, 1);
    // sort communications in order of start metric (could be % or hard start)
    communicationsListCopy.sort(compareCommunications);
    setCommunicationsList(communicationsListCopy);
  };

  // handles saving for all fields in communication entry
  const handleUpdateCommunication = (field: string, id: number, val: any, medium: string | undefined, lang: string | undefined) => {
    const objIndex = communicationsList.findIndex((obj) => obj.id === id);
    // make a copy
    const communicationsListCopy = stateDeepCopy(communicationsList);
    if (
      field === "type" ||
      field === "priority" ||
      field === "medium" ||
      field === "notification_minimum_frequency" ||
      field === "subject" ||
      field === "count" ||
      field === "notification_strategy" ||
      field === "message" ||
      field === "notification_minimum_frequency_unit"
    ) {
      // if sendonceduringinterval, we need to save/update some default values for other props
      if (
        field === "notification_strategy" &&
        val === "sendonceduringinterval"
      ) {
        communicationsListCopy[objIndex].properties[field] = val;
        communicationsListCopy[objIndex].properties[
          "notification_minimum_frequency"
        ] = 1;
        communicationsListCopy[objIndex].properties["count"] = 1;
      } else if ((field === "subject" || field === "message") && medium && lang) {
        // 'email', 'app', and 'sms' keys are removed if the corresponding nested values contain no data
        // therefore, we need to check if they exist before doing anything
        //  if field exists, update its nested values
        //  if not, create the needed objects, and THEN update nested values
        if (field === "subject") {
          if (medium in communicationsListCopy[objIndex].properties.message) {
            console.log(communicationsListCopy[objIndex].properties.message[medium][lang].subject)
            communicationsListCopy[objIndex].properties.message[medium][lang].subject = val
          } else {
            const newLocalizationSettings = new LocalizationSettings("", "", "");
            const locationSettingsDataProps = { lang: lang, localizationSettings: newLocalizationSettings } as unknown as LocationSettingsDataProps
            communicationsListCopy[objIndex].properties.message[medium] = new MediumSettings([locationSettingsDataProps])
            communicationsListCopy[objIndex].properties.message[medium][lang] = new LocalizationSettings("", "", "");
            communicationsListCopy[objIndex].properties.message[medium][lang].subject = val
          }
        }
        // 'email', 'app', and 'sms' keys are removed if the corresponding nested values contain no data
        // therefore, we need to check if they exist before doing anything
        //  if field exists, update its nested values
        //  if not, create the needed objects, and THEN update nested values
        if (field === "message") {
          if (medium in communicationsListCopy[objIndex].properties.message) {
            communicationsListCopy[objIndex].properties.message[medium][lang].body = val
            communicationsListCopy[objIndex].properties.message[medium][lang].text = val
          } else {
            const newLocalizationSettings = new LocalizationSettings("", "", "");
            const locationSettingsDataProps = { lang: lang, localizationSettings: newLocalizationSettings } as unknown as LocationSettingsDataProps
            communicationsListCopy[objIndex].properties.message[medium] = new MediumSettings([locationSettingsDataProps])
            communicationsListCopy[objIndex].properties.message[medium][lang] = new LocalizationSettings("", "", "");
            communicationsListCopy[objIndex].properties.message[medium][lang].body = val
            communicationsListCopy[objIndex].properties.message[medium][lang].text = val
          }
        }
      } else {
        communicationsListCopy[objIndex].properties[field] = val;
      }
    } else {
      communicationsListCopy[objIndex][field] = val;
    }
    // sort communications in order of start metric (could be % or hard start)
    communicationsListCopy.sort(compareCommunications);
    console.log(communicationsListCopy)
    setCommunicationsList(communicationsListCopy);
  };

  const communications = communicationsList.map((comm) => {
    return (
      <Communication
        key={comm.id}
        handleUpdateCommunication={handleUpdateCommunication}
        handleDeleteCommunication={handleDeleteCommunication}
        communication={comm}
        editMode={editMode}
        prioritiesList={prioritiesList}
        handleCopyCommunication={handleCopyCommunication}
      />
    );
  });

  const handleCopyCommSet = async () => {
    // update db
    const url: string =
      process.env.REACT_APP_API_URL + "/rpc/fn_copy_comm_set";
    const requestSettings = {
      url: url,
      method: "POST",
      body: { setid: communicationSetID, copied_ids: {} },
      headers: {
        Authorization: "Bearer " + process.env.REACT_APP_POSTGREST_JWT,
        "Content-Type": "application/json",
        "Content-Profile": testing ? "test" : "build"
      },
    };

    await fetchData(requestSettings, async function (data: CopyProps) {
      const commSetIDIndex = "" + communicationSetID || "0";
      const newCommSetID = data.communication_set[commSetIDIndex]
      setCommunicationsSetID(newCommSetID);

      // grab the newly added comm set, add to redux
      const thisNewCommSetResults = await CommunicationSet.queryTable([
        {
          column: "id",
          operator: postgrest_operators.eq,
          value: newCommSetID.toString(),
        },
      ]);
      const thisNewCommSet = thisNewCommSetResults[0];
      setCommunicationsSetName(thisNewCommSet.name);
    });

  };

  // this operates under the assumption that a commset should
  // probably have at least 1 child communication
  const noCommunicationsToDisplayContent =
    communicationsList.length < 1 ? (
      <div style={{ padding: "30px", textAlign: "center", fontSize: "9pt" }}>
        {t('communication_set_empty_label')}
      </div>
    ) : null;

  // we shouldn't name a comm set unless you're sharing it
  // so to start we should just see new communication and search
  // if we add a comm to the anonymous comm set you should see new communication, delete, and share
  // if we load an existing communication set you should see edit, duplicate, and delete (edited)
  // if we edit an existing comm set you should be able to edit the name of the comm set as well as see new communication, duplicate, and delete
  const content = (<div> <Box sx={{ marginTop: "10px" }} data-testid="communicationsSetEditorTest">
    <Grid container style={{}}>
      <Grid item xs={12}>
        <div>
          {/* stack for controls next to dropdown */}
          {defaultEditMode && (
            <Stack
              style={{
                marginRight: "10px",
                marginBottom: "10px",
                float: "right",
              }}
              direction="row"
              spacing={0}
            >

              {/* copy */}
              {/* TODO - also need to check if commsetID isnt -1 before this can show */}
              {communicationSetID != -1 &&
                communicationSetName !== null &&
                communicationSetName != "" && communicationSetShared && <InteractionCopyButton
                  type="communication set"
                  communicationSetID={communicationSetID}
                  setEditMode={setEditMode}
                  handleCopyCommSet={handleCopyCommSet}
                />}
              <div style={{ height: "50px" }}>{/* spacer */}</div>
            </Stack>
          )}
          <div style={{ paddingBottom: "10px" }}>

            {!props.previewMode && !searchMode && (
              <div>
                <h4 id="outlined-required-label-priority" style={{ marginLeft: "15px", marginBottom: "-80px" }}>
                  Communication Set Name:               {/* editMode - edit name and add comms*/}
                  {/* turn off until we get the shared comm set stuff squared away */}
                  {communicationSetName !== null &&
                    communicationSetShared === false && (
                      <Tooltip title={"Share Communication Set"}>
                        <IconButton
                          data-testid="commSetEditModeButton"
                          onClick={(e) => {
                            console.log(communicationSet)
                            const updatedCommunicationSet = communicationSet?.update('shared', true)
                            updatedCommunicationSet?.save();
                            setCommunicationsSetShared(true);
                            setEditMode(false);
                          }}
                          aria-label="delete"
                        >
                          <IosShareIcon
                          // sx={{ color: editMode ? "red" : "gray" }}
                          />
                        </IconButton>
                      </Tooltip>
                    )}
                  {communicationSetShared && <Tooltip title={"Edit shared communication set"}>
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        setEditMode(!editMode);
                      }}
                    >
                      {!editMode && <LockIcon style={{ color: "red" }} />}
                      {editMode && <LockOpenIcon style={{ color: "#1976d2" }} />}
                    </IconButton>
                  </Tooltip>}
                </h4>
                <TextField
                  disabled={!editMode}
                  sx={{ width: "98%", marginLeft: "10px", height: "75px", marginTop: "-10px" }}
                  id="outlined-required"
                  // label="Assigned Communication Set"
                  value={communicationSetName}
                  inputProps={{ "data-testid": "commSetEditName" }}
                  defaultValue={communicationSetName}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    console.log(event.target.value)
                    setCommunicationsSetName(event.target.value);
                  }}
                /></div>
            )}
            {/* SHARED COMMSET WARNING */}
            {/* turn off warning until we get the shared comm set stuff squared away */}
            {false && editMode &&
              communicationSetName !== null &&
              communicationSetName.length > 0 && (
                <p style={{ fontSize: "8pt", color: "red" }}>
                  &nbsp; &nbsp;{" "}
                  <WarningIcon sx={{ fontSize: "12pt", color: "red" }} />
                  &nbsp; WARNING: You are directly modifying the contents of
                  a shared communication set!
                </p>
              )}
          </div>
        </div>
      </Grid>
    </Grid>
  </Box>
    {/* <div style={{ display: "flex", justifyContent: "flex-end" }}> */}
    {editMode && (
      <div style={{ textAlign: "center" }}>
        <Tooltip title={"Add new communication"}>
          <Button
            data-testid="addNewCommunicationButton"
            onClick={addNewCommunication}
            color="success"
            variant="contained"
          >
            <AddIcon />
            {"NEW COMMUNICATION"}
          </Button>
        </Tooltip>
      </div>
    )}

    {/* </div > */}
    <div
      style={{
        margin: "10px",
        padding: "10px",
        border: "1pt solid lightgray",
      }}
    >
      <div>
        {isLoading && <LinearProgress />}
        {!isLoading && communications}
        {!isLoading && noCommunicationsToDisplayContent}
      </div>
    </div>
    <br />
  </div>)
  if (props.previewMode) {
    return (content)
  } else {
    return (
      <EditorWrapper
        save={async () => {
          if (props.handleUpdateCommSet) {
            props.handleUpdateCommSet(communicationSetID);
          }
          await assignSetToEntity();
          await saveCommunicationsData(); // commit individual comms to db via loop
          communicationSet?.update('name', communicationSetName).save()
        }}
        //saveText={props.resourceName == "interval" && interval ? "SAVE TO " + interval.name : "SAVE"}
        table="Communications"
        title={props.resourceName + " ID#" + props.resourceID}
        inDrawer={props.inDrawer}
        drawerAccordion={props.drawerAccordion}
        intervalSetEditMode={props.intervalSetEditMode}
      >
        {content}

      </EditorWrapper>
    );
  }
};

export default CommunicationSetEditor;
